var { Platform } = require('react-native');

if (Platform.OS === 'web') {
  module.exports = {
    unlink: () => {}
  }
}
